import { render, staticRenderFns } from "./OperaHotCityWindow.vue?vue&type=template&id=23323528&scoped=true&"
import script from "./OperaHotCityWindow.vue?vue&type=script&lang=js&"
export * from "./OperaHotCityWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaHotCityWindow.vue?vue&type=style&index=0&id=23323528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23323528",
  null
  
)

export default component.exports